import { combineReducers } from 'redux'
import * as types from 'models/actionTypes'

export const initialState = {
    delayedScreenshot: {
        currentTimeoutId: null,
        firstScreenshotTime: 0,
        firstFurnitureScreenshotDone: false,
    },
    furnitureFilter: {
        filterSource: null,
        categoryLabel: null,
        subCategoryLabel: null,
    },
}

export const furnitureFilter = (state = initialState.furnitureFilter, action) => {
    switch (action.type) {
        case types.FURNITURE_FILTER_UPDATE: {
            const { trackingInfo } = action

            return trackingInfo || state
        }

        default:
            return state
    }
}

const delayedScreenshot = (state = initialState.delayedScreenshot, action) => {
    switch (action.type) {
        case types.DELAYED_SCREENSHOT_SCHEDULED:
            return {
                ...state,
                currentTimeoutId: action.timeoutId,
            }
        case types.DELAYED_SCREENSHOT_SENT:
            return {
                ...state,
                currentTimeoutId: null,
            }
        case types.SET_INITIAL_LOADING:
            if (action.initialLoading) {
                return initialState.delayedScreenshot
            }
            return {
                ...state,
                firstScreenshotTime: window.performance.now(),
            }
        case types.FIRST_RENDER_ITEM_SCREENSHOT_DONE: {
            return {
                ...state,
                firstFurnitureScreenshotDone: true,
            }
        }
        default:
            return state
    }
}

export default combineReducers({
    delayedScreenshot,
    furnitureFilter,
})
